import { Component, signal, ChangeDetectionStrategy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RealmService } from '../../../authentication/realm.service';
import { RealmConfiguration } from '../../../../environments/constants';
import { MatTooltip } from '@angular/material/tooltip';
import { buildDate, commitHash } from '../../../../environments/version';
import { sentryLogger } from 'shared/core';

@Component({
  selector: 'app-version-info',
  imports: [MatTooltip, DatePipe],
  templateUrl: './version-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './version-info.component.scss',
})
export class VersionInfoComponent {
  frontendVersionInfo$ = signal<string>('');
  frontendBuildDate$ = signal<string>('');
  apiVersionInfo$ = signal<string>('');
  displayVersionInfo$ = signal(false);

  constructor(private readonly realmService: RealmService) {
    const realm = this.realmService.getRealm();
    const frontendVersionInfo = commitHash.substring(0, 20);
    const frontendBuildDate = buildDate;
    const isInternalRealm =
      RealmConfiguration.internalRealms.indexOf(realm) >= 0;

    this.frontendVersionInfo$.set(frontendVersionInfo);
    this.frontendBuildDate$.set(frontendBuildDate);
    this.displayVersionInfo$.set(isInternalRealm);

    sentryLogger.setGlobalScopeAttributes({
      app_client: 'helper-client',
      app_frontend_version: frontendVersionInfo,
      app_frontend_build_date: frontendBuildDate,
      app_realm: realm,
      app_is_internal_realm: isInternalRealm,
    });
  }
}
